'use client';

import { Button } from '@ophelos/ui/components/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '@/hooks/useTranslation';

interface BreadcrumbProps {
  label?: string;
  to?: string;
  onClick?: () => void;
}

export function Breadcrumb({ label, to = '/dashboard', onClick }: BreadcrumbProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const displayLabel = label || t('common.backToDashboard');

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(to);
    }
  };

  return (
    <div className="absolute top-0 left-0 right-0 z-50 p-4">
      <Button variant="ghost" size="sm" onClick={handleClick} className="gap-2 text-muted-foreground hover:text-foreground">
        <ArrowLeft className="size-4" />
        {displayLabel}
      </Button>
    </div>
  );
}
